'use client';

import type { ReactNode } from 'react';

import { Carousel, CarouselNavSize, CarouselNext, CarouselPrevious } from '@vs-shop/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

type Props = {
  children: ReactNode;
};

export default function HomepageBrandLogosCarousel({ children }: Props) {
  return (
    <Carousel
      plugins={[Autoplay({ delay: 5000 })]}
      className="mt-6 lap:mt-12"
      data-slot="homepage-brand-carousel"
    >
      <div className="grid lap:mx-24">{children}</div>
      <div className="flex justify-center gap-x-4 pt-8 lap:hidden">
        <CarouselPrevious navSize={CarouselNavSize.MD} position="free" />
        <CarouselNext navSize={CarouselNavSize.MD} position="free" />
      </div>
      <div className="hidden lap:block">
        <CarouselPrevious navSize={CarouselNavSize.LG} />
        <CarouselNext navSize={CarouselNavSize.LG} />
      </div>
    </Carousel>
  );
}
